import api from '../config/api';
import {
  UserGeneratedContentResponse,
  UGCFormState,
  UserGeneratedContentStatus,
} from '../models/user-generated-contents/types';

function withProcessedFlag(data: UGCFormState): object {
  if (!data.content_cover?.image) return data;
  const { status } = data.content_cover.image;
  const processed = status === 'processing' || status === 'completed';
  return {
    ...data,
    content_cover: {
      ...data.content_cover,
      image: { ...data.content_cover.image, processed },
    },
  };
}

export const updateStatusUrlMap = {
  active: 'restore',
  submitted: 'submit',
  archived: 'archive',
} as const;

class UserGeneratedContentService {
  id: number | undefined;

  constructor(id: number | undefined) {
    this.id = id;
  }

  fetch = () => {
    return api.get<UserGeneratedContentResponse>(
      `/user_generated_contents/${this.id}`
    );
  };

  create = (data: UGCFormState) => {
    return api.post<UserGeneratedContentResponse>(
      '/user_generated_contents',
      withProcessedFlag(data)
    );
  };

  update = (data: UGCFormState) => {
    return api.put<UserGeneratedContentResponse>(
      `/user_generated_contents/${this.id}`,
      withProcessedFlag(data)
    );
  };

  updateStatus = (status: UserGeneratedContentStatus) => {
    const path = `/user_generated_contents/${this.id}/${updateStatusUrlMap[status]}`;

    return api.post<UserGeneratedContentResponse>(path);
  };
}

export default UserGeneratedContentService;
